import { lazy } from "react";
import type { RouteObject } from "react-router";

const SalesIndex = lazy(() => import("./pages/page"));
const Items = lazy(() => import("./pages/items/page"));

// Customers
const Customers = lazy(() => import("./pages/customers/page"));
const CustomerDetail = lazy(() => import("./pages/customers/[id]/page"));

// Quotations
const Quotations = lazy(() => import("./pages/quotations/page"));
const QuotationNew = lazy(() => import("./pages/quotations/new/page"));
const QuotationDetail = lazy(() => import("./pages/quotations/[id]/page"));
const QuotationEdit = lazy(() => import("./pages/quotations/[id]/edit/page"));

// Sales Orders
const SalesOrders = lazy(() => import("./pages/sales-orders/page"));
const SalesOrderNew = lazy(() => import("./pages/sales-orders/new/page"));
const SalesOrderDetail = lazy(() => import("./pages/sales-orders/[id]/page"));
const SalesOrderEdit = lazy(() => import("./pages/sales-orders/[id]/edit/page"));

export const salesRoutes: RouteObject[] = [
  { index: true, Component: SalesIndex },
  { path: "dashboard", Component: SalesIndex },
  { path: "items", Component: Items },

  // Customers
  { path: "customers", Component: Customers },
  { path: "customers/:id", Component: CustomerDetail },

  // Quotations
  { path: "quotations", Component: Quotations },
  { path: "quotations/new", Component: QuotationNew },
  { path: "quotations/:id", Component: QuotationDetail },
  { path: "quotations/:id/edit", Component: QuotationEdit },

  // Sales Orders
  { path: "sales-orders", Component: SalesOrders },
  { path: "sales-orders/new", Component: SalesOrderNew },
  { path: "sales-orders/:id", Component: SalesOrderDetail },
  { path: "sales-orders/:id/edit", Component: SalesOrderEdit },
];
